module.exports = __webpack_public_path__ + "media/src/images/mails/gray-cfb38a54b7cb041feba481c78d582170.png";